import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { fDate12 } from '../../../utils/formatTime';
import { userActions, authActions } from "../../../_store";

import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import EmojiPicker from "@emoji-mart/react";
import './Emoji.css'


const MsgBox = ({ chatDetail, openMsg, PerfectScrollbar, offMsg }) => {
   const dispatch = useDispatch();
   const scrollRef = useRef();

   const currentUser = useSelector((x) => x.auth.user);
   const messageList = useSelector((x) => x.users.messageList);
   const [isShowEmojiPicker, setIsShowEmojiPicker] = useState(false)
   const emojiPickerRef = useRef(null)
   const [windowHeight, setWindowHeight] = useState(window.innerHeight);
   const [messageText, setMessageText] = useState("");
   const messageTextRef = useRef(messageText)
   const [colorDetail, setColorDetail] = useState({
      SenderContBgColor: "",
      SenderContTextColor: "",
      ReceiverContBgColor: "",
      ReceiverContTextColor: ""
   });

   useEffect(() => {
      const handleResize = () => {
         setWindowHeight(window.innerHeight);
      };
      const handleOutsideClick = (e) => {
         if (emojiPickerRef.current && !emojiPickerRef.current.contains(e.target)) {
            setIsShowEmojiPicker(false)
         }
      }

      window.addEventListener('resize', handleResize);
      window.addEventListener("mousedown", handleOutsideClick)
      return () => {
         window.removeEventListener('resize', handleResize);
         window.removeEventListener("mousedown", handleOutsideClick)
      };
   }, []);

   useEffect(()=>{
      if(isShowEmojiPicker){
         window.addEventListener("keydown", handleKeyDown)
      }else{
         window.removeEventListener("keydown", handleKeyDown)
      }

      return()=>{
         window.removeEventListener("keydown", handleKeyDown)
      }
   },[isShowEmojiPicker])

   useEffect(()=>{
      messageTextRef.current = messageText
   },[messageText])
   
   const scrollToBottom = () => {
      if (scrollRef.current && scrollRef.current._container) {
         scrollRef.current._container.scrollTop = scrollRef.current._container.scrollHeight;
      }
   };

   useEffect(() => {
      const SenderDetail = userTypeBasedColor(chatDetail.SenderUserType);
      const ReceiverDetail = userTypeBasedColor(chatDetail.ReceiverUserType);

      const updatedColor = {
         SenderContBgColor: SenderDetail.imgContBgColor,
         SenderContTextColor: SenderDetail.imgContTextColor,
         ReceiverContBgColor: ReceiverDetail.imgContBgColor,
         ReceiverContTextColor: ReceiverDetail.imgContTextColor,
      };
      setColorDetail(updatedColor);
   }, [chatDetail]);

   useEffect(() => {
      scrollToBottom();
      
   }, [openMsg, messageList]); // Include messageList and openMsg

   const sampleContainer = {
      height: (windowHeight - 160)?.toString() + "px"
   };

   // Adjust color brightness function
   const adjustColorBrightness = (color, amount) => {
      let usePound = false;
      if (color[0] === "#") {
         color = color.slice(1);
         usePound = true;
      }

      let num = parseInt(color, 16);
      let r = (num >> 16) + amount;
      let g = ((num >> 8) & 0x00FF) + amount;
      let b = (num & 0x0000FF) + amount;

      r = Math.max(Math.min(255, r), 0);
      g = Math.max(Math.min(255, g), 0);
      b = Math.max(Math.min(255, b), 0);

      return (usePound ? "#" : "") + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
   };

   const userTypeBasedColor = (UserType) => {
      let baseColor = '#3498DB'; // Default base color

      switch (UserType) {
         case 'SuperAdmin':
            baseColor = '#00AEEF'; // Blue
            break;
         case 'Admin':
            baseColor = '#E02C2C'; // Red
            break;
         case 'Order Analyst':
            baseColor = '#80C241'; // Green
            break;
         case 'Dispatcher':
            baseColor = '#737b8b'; // Yellow
            break;
         case 'Warehouse Manager':
            baseColor = '#EA4B8D'; // Dark blue for others
            break;
         default:
            baseColor = '#004b87'; // Dark blue for others
      }

      const imgContBgColor = adjustColorBrightness(baseColor, 80);
      const imgContTextColor = adjustColorBrightness(baseColor, -80);

      return { imgContBgColor, imgContTextColor };
   };

   const handleRefreshChat = () => {
      if (chatDetail.SenderID > 0 && chatDetail.ReceiverID > 0) {
         dispatch(userActions.getAndUpdateMessageList({ SenderID: chatDetail.SenderID, ReceiverID: chatDetail.ReceiverID }))
            .then((response) => {
               if (response?.type === 'users/getAndUpdateMessageList/fulfilled') {
                  let userDetail = { ...currentUser };
                  userDetail.NotificationCount = response?.payload?.NotificationCount;
                  dispatch(authActions.updateLocalStorage(userDetail));
               }
            });
      }
   };

   const handleChangeMessage = (value, e) => {
      if (value?.trim()) {
         const currencyPattern = /^(?!.*#)/;
         if (currencyPattern.test(value)) {
            setMessageText(value);
         }

      } else {
         setMessageText(value?.trim());
      }

   };

   const handleKeyPressMessagee = (event) => {
      if (event?.key === 'Enter' && event?.keyCode === 0 && event.shiftKey === false) {
         handleSendMessage();
      }
   };

   const handleSendMessage = () => {
      if (messageTextRef?.current?.trim()) {
        
         dispatch(userActions.sendMessage({ messageText: messageTextRef?.current?.trim(), senderId: currentUser.Id, receiverId: chatDetail.SenderID })).then((response) => {
            if (response?.type === 'users/sendMessage/fulfilled') {
               let userDetail = { ...currentUser };
               userDetail.NotificationCount = response?.payload?.NotificationCount;
               dispatch(authActions.updateLocalStorage(userDetail));
               scrollToBottom();
               setMessageText("");
            }
         });
      }
   };

   const handleEmojiPicker = () => {
      setIsShowEmojiPicker(!isShowEmojiPicker)
   }

   const handleKeyDown=(e)=>{

    if(e.key === 'Enter' && e.shiftKey === false){
      setIsShowEmojiPicker(false)
      handleSendMessage();
    }
   }

   return (
      <>
         {
            isShowEmojiPicker && <>
               <div ref={emojiPickerRef} style={{ position: 'absolute', bottom: '100px', zIndex: "1000" }} >
                  <EmojiPicker
                     data={data}
                     onEmojiSelect={(emoji) => setMessageText((prevMessageText)=> prevMessageText + emoji.native)}
                     emojiButtonSize={30}
                     emojiSize={20}
                     maxFrequentRows={0}
                     previewPosition="none"
                     skinTonePosition="none"
                  ></EmojiPicker>
               </div>

            </>
         }
         <div className={`card chat dz-chat-history-box ${openMsg ? "" : "d-none"}`}>
            <div className="card-header chat-list-header text-center">
               <a className="dz-chat-history-back" onClick={() => {  offMsg() }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                     <g fill="none" fillRule="evenodd">
                        <rect fill="#000000" opacity="0.3" x="14" y="7" width="2" height="10" rx="1" />
                        <path d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z" fill="#000000" fillRule="nonzero" transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997)" />
                     </g>
                  </svg>
               </a>
               <div>
                  <h6 className="mb-1">Chat with {chatDetail.FirstName}</h6>
               </div>
               <div className="dropdown">
                  <a onClick={() => handleRefreshChat()}>
                     <i className="fa fa-sync"></i>
                  </a>
               </div>
            </div>
            <PerfectScrollbar ref={scrollRef} className={`card-body msg_card_body dz-scroll ${openMsg ? "ps ps--active-y" : ""}`} id="DZ_W_Contacts_Body3" style={sampleContainer}>
               {messageList && messageList.length > 0 ? (
                  messageList.map((val, index) => (
                     <div key={index}>
                        {val.SenderID !== currentUser.Id ? (
                           <div className="d-flex justify-content-start mb-4">
                              <div className="img_cont_msg" style={{ backgroundColor: colorDetail.SenderContBgColor, color: colorDetail.SenderContTextColor }}>
                                 <div className="rounded-circle user_char">
                                    {chatDetail.FirstName?.charAt(0).toUpperCase()}{chatDetail.LastName?.charAt(0).toUpperCase()}
                                 </div>
                              </div>
                              <div className="msg_cotainer">
                                 {val.MessageText}
                                 <span className="msg_time">{val?.CreatedDate && fDate12(val?.CreatedDate)}</span>
                              </div>
                           </div>
                        ) : (
                           <div className="d-flex justify-content-end mb-4">
                              <div className="msg_cotainer_send">
                                 {val.MessageText}
                                 <span className="msg_time_send">{val?.CreatedDate && fDate12(val?.CreatedDate)}</span>
                              </div>
                              <div className="img_cont_msg" style={{ backgroundColor: colorDetail.ReceiverContBgColor, color: colorDetail.ReceiverContTextColor }}>
                                 <div className="rounded-circle user_char">
                                    {currentUser.FirstName?.charAt(0).toUpperCase()}{currentUser.LastName?.charAt(0).toUpperCase()}
                                 </div>
                              </div>
                           </div>
                        )}
                     </div>
                  ))
               ) : (
                  <span>No chat available</span>
               )}
            </PerfectScrollbar>
            <div className="card-footer card-footer-custom type_msg">
               <div className="input-group">
                  <textarea
                     className="form-control"
                     placeholder="Type your message..."
                     value={messageText}
                     maxLength={1500}
                     onKeyPress={(e) => handleKeyPressMessagee(e)}
                     onChange={(e) => handleChangeMessage(e.target.value, e)}
                  />
                  <div className="input-group-append">
                     <button type="button" className="btn btn-primary me-1" onClick={handleSendMessage}>
                        <i className="fa fa-location-arrow"></i>
                     </button>
                     <button type="button" className="btn btn-primary" onClick={handleEmojiPicker}>
                        <i className="fas fa-icons"></i>
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </>

   );
};

export default MsgBox;
